import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import WarehouseService from "../../services/WarehouseService";
import DataTableProductWarehousePrices from "../../ui/DataTableProductWarehousePrices";

// Barcodes of one code article in a warehouse, opened in a new tab from the
// "Par code article" view of /warehouseProductsByPrices
const ProductCodeBarcodes = () => {
  const [searchParams] = useSearchParams();
  const idWarehouse = searchParams.get("idWarehouse");
  const productCode = searchParams.get("code");
  const [nameWarehouse, setNameWarehouse] = useState("");
  const [deviseWarehouse, setDeviseWarehouse] = useState("");
  const [refrech, setRefrech] = useState(false);

  useEffect(() => {
    if (!idWarehouse) {
      return;
    }
    WarehouseService.getAllAchatAndCAWarehouseById(idWarehouse)
      .then((response) => {
        if (response.data["success"]) {
          setNameWarehouse(response.data["warehouse"]);
          setDeviseWarehouse(response.data["devise"]);
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  }, [idWarehouse]);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item">Prix</li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Code article {productCode}
                </li>
              </ol>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-6 col-12">
              <div className="info-box bg-gray-dark">
                <span className="info-box-icon">
                  <i className="fas fa-barcode"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Code article</span>
                  <span className="info-box-number">{productCode}</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-12">
              <div className="info-box bg-gray">
                <span className="info-box-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Dépôt</span>
                  <span className="info-box-number">{nameWarehouse}</span>
                </div>
              </div>
            </div>
          </div>

          {idWarehouse && productCode ? (
            <div className="row">
              <div className="col-sm-12">
                <DataTableProductWarehousePrices
                  idWarehouse={idWarehouse}
                  productCode={productCode}
                  refrech={refrech}
                  setRefrech={setRefrech}
                  devise={deviseWarehouse}
                  nameWarehouse={nameWarehouse}
                />
              </div>
            </div>
          ) : (
            <p>Code article ou dépôt manquant.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default ProductCodeBarcodes;
